<template>
  <el-row>
    <el-col>
      <span class="cs-title">收据记录</span>
      <span class="cs-blue cs-accountList-viewDetail" @click="viewDetails">
        <span>查看明细</span>
        <i class="fa fa-chevron-down" v-if="!isShowDetails" aria-hidden="true"></i>
        <i class="fa fa-chevron-up" v-if="isShowDetails" aria-hidden="true"></i>
      </span>
      <el-row class="hidden-xs-only">
        <el-col :span="18">
          <label> &nbsp; </label>
        </el-col>
      </el-row>
      <el-row class="grid-content" v-if="isShowDetails">
        <el-col :span="22" :xs="24">
          <el-table ref="bounsPointHistory" :data="receiptHistory" :header-row-class-name="'el-table-header'" :cell-class-name="cellStyle">
            <el-table-column prop="CreateTimeString" label="日期" class-name="courses-history-colmun-width" />
            <el-table-column prop="ReceiptTypeText" label="类型" class-name="courses-history-colmun-width" />
            <el-table-column prop="Summary" label="摘要" class-name="courses-history-colmun-width" />
            <el-table-column prop="Actions" label="" fixed="right" :min-width="80">
              <template slot-scope="scope">
                <el-button type="text" size="medium" @click="downloadReceipt(scope.row)">下载</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-col>
      </el-row>
    </el-col>
  </el-row>
</template>

<script>
import { downloadFile } from "@/config/mUtils";
import { getStudentReceiptHistory } from "@/service/student.service";
import { getBlobFileUrlById, downloadFileToBlob } from "@/service/blobStorage.service";

let moment = require("moment");
export default {
  props: ["studentId"],
  data() {
    return {
      receiptHistory: [],
      isShowDetails: false,
    };
  },
  created() {
    this.initData();
  },
  methods: {
    cellStyle(cell) {
      let cellClass = "";
      if ((cell.rowIndex + 1) % 2 == 1) {
        cellClass = "el-table-cell-single";
      } else {
        cellClass = "el-table-cell-double";
      }
      return cellClass;
    },
    initData() {
      getStudentReceiptHistory(this.studentId).then((result) => {
        if (!!result && result.success) {
          this.receiptHistory = result.data;
          this.receiptHistory.forEach((element) => {
            element.CreateTimeString = !!element.CreateTime
              ? moment(moment.utc(element.CreateTime).toDate()).format(
                  "YYYY/MM/DD"
                )
              : "";
          });
        }
      });
    },
    viewDetails() {
      this.isShowDetails = !this.isShowDetails;
    },
    downloadReceipt(row) {
      let fileId = row.FileId;
      getBlobFileUrlById(fileId)
        .then((result) => {
          if (!!result && result.success) {
            let { Url, FileName } = result.data;
            downloadFileToBlob(Url, 0).then((res) => {
              downloadFile({data: res.data, filename: FileName});
            });
            // downloadFileByUrl(Url, FileName);
          } else {
            if (!!result.message) {
              this.$message.error(result.message);
            }
          }
        })
        .catch(() => {});
    },
  },
};
</script>

<style land="sass" scoped>
.cs-accountList-viewDetail {
  cursor: pointer;
}
</style>


// WEBPACK FOOTER //
// src/components/studentProfile/studentReceiptHistory.vue